import commonConfig from "../../../../config/common";

const DEFAULT_DISPLAYABLE_CHILD_LINK_COUNT = 10;

const getDisplayableChildLinkCountForCategory = ({ categoryId }) =>
  commonConfig.api.category.configuredDisplayableChildLinkCounts[categoryId] ||
  DEFAULT_DISPLAYABLE_CHILD_LINK_COUNT;

export default getDisplayableChildLinkCountForCategory;
